import { useWidgetStore } from './use-widget-store';

const useConfigStore = () => {
  return useWidgetStore(state => state.config);
};

const useInterfaceStore = () => {
  return useWidgetStore(state => state.interface);
};

const useChatStore = () => {
  return useWidgetStore(state => state.chat);
};

const useContextStore = () => {
  return useWidgetStore(state => state.context);
};

export {
  useConfigStore,
  useInterfaceStore,
  useChatStore,
  useContextStore,
  useWidgetStore
};
